import { forwardRef, RefObject } from 'react';
import { observer } from 'mobx-react-lite';
import { SVG } from '../../..';
import { Button } from 'components/ui';
import { Wrapper } from './add-button.styled';
import { Icons } from 'assets';

interface IProps {
  isMedia: boolean;
  limit?: number;
}

export const AddButton = observer(
  forwardRef<HTMLInputElement, IProps>(({ isMedia, limit }, ref) => {
    return (
      <Wrapper alignStart={!isMedia}>
        <Button
          leftIcon={<SVG src={Icons[isMedia ? 'AddImage' : 'Plus']} />}
          mode="neutral"
          variant="outline"
          size="s"
          onClick={() => (ref as RefObject<HTMLInputElement>).current?.click()}
        >
          Добавить {isMedia ? 'изображение' : 'файл'}
        </Button>
        {!!limit && (
          <div>
            Максимальное количество {isMedia ? 'изображений' : 'файлов'}:{' '}
            {limit}
          </div>
        )}
      </Wrapper>
    );
  })
);
